"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.ActionButtonsUserMember = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _CheckInCircle = _interopRequireDefault(require("@insided/destination/icons/CheckInCircle"));

var _MoreHoriz = _interopRequireDefault(require("@insided/shared/icons/MoreHoriz"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _index = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/dropdown/index"));

var _classnames = _interopRequireDefault(require("classnames"));

var _GroupAddMembersModal = _interopRequireDefault(require("./GroupAddMembersModal"));

var _GroupEditFeaturedTopicsModal = _interopRequireDefault(require("./GroupEditFeaturedTopicsModal"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'group-details';
exports.cssAnchorName = cssAnchorName;

var ActionButtonsUserMember = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ActionButtonsUserMember, _Component);

  var _super = _createSuper(ActionButtonsUserMember);

  function ActionButtonsUserMember() {
    var _this;

    (0, _classCallCheck2.default)(this, ActionButtonsUserMember);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      showAddMembersModal: false,
      showEditFeaturedTopicsModal: false,
      showMessage: false,
      messageStatus: 'success',
      messageText: null
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openAddMembersModal", function () {
      _this.setState({
        showAddMembersModal: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "openEditFeaturedTopicsModal", function () {
      _this.setState({
        showEditFeaturedTopicsModal: true
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ActionButtonsUserMember, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          groupId = _this$props.groupId,
          isUserSubscribed = _this$props.isUserSubscribed,
          unsubscribe = _this$props.unsubscribe,
          subscribe = _this$props.subscribe,
          leaveGroup = _this$props.leaveGroup,
          onManageGroupClick = _this$props.onManageGroupClick,
          curatedContentTitle = _this$props.curatedContentTitle,
          curatedContentTopics = _this$props.curatedContentTopics,
          onSaveTopics = _this$props.onSaveTopics,
          isCurrentUserModerator = _this$props.isCurrentUserModerator,
          isUserMember = _this$props.isUserMember,
          communityLocale = _this$props.communityLocale;
      var _this$state = this.state,
          showAddMembersModal = _this$state.showAddMembersModal,
          showEditFeaturedTopicsModal = _this$state.showEditFeaturedTopicsModal,
          showMessage = _this$state.showMessage,
          messageStatus = _this$state.messageStatus,
          messageText = _this$state.messageText;
      var moderatorActions = [{
        className: 'user-action__group-add-member-btn',
        action: this.openAddMembersModal,
        elementName: 'Group Clicked add members',
        text: 'groups.add.members'
      }, {
        className: 'user-action__group-manage-btn',
        action: onManageGroupClick,
        elementName: 'Group Clicked manage groups on the destination',
        text: 'groups.manage.group'
      }, {
        className: 'user-action__group-edit-featured-topics-btn',
        action: this.openEditFeaturedTopicsModal,
        elementName: 'Group Clicked change featured topics',
        text: 'groups.edit.featured.content'
      }];
      return (0, _preact.h)("div", {
        className: "group-details_hero__user-actions"
      }, isUserMember ? (0, _preact.h)("div", {
        className: "group-details_hero__user-actions__member-actions"
      }, (0, _preact.h)("a", {
        type: "button",
        className: (0, _classnames.default)('btn--cta', 'create-group-topic-btn', 'is-hidden-S'),
        href: (0, _absoluteUrlRuntime.resolveUrl)("/topic/new?fid=".concat(groupId))
      }, (0, _preact.h)(_phrase.default, {
        p: "main.navigation.add_topic"
      })), (0, _preact.h)("div", {
        className: (0, _classnames.default)('group-details_hero__user-joined', 'btn', 'btn--secondary')
      }, (0, _preact.h)("span", {
        "aria-hidden": "true",
        className: "group-details_hero__user-joined-icon"
      }, (0, _preact.h)(_CheckInCircle.default, {
        width: 24,
        height: 24,
        fill: "#3CB54A"
      })), (0, _preact.h)("span", null, (0, _preact.h)(_phrase.default, {
        p: "groups.joined"
      })))) : null, (0, _preact.h)(_index.default, {
        size: "S",
        align: "right",
        popupName: "group-actions-list",
        trigger: (0, _preact.h)(_Button.default, {
          type: "button",
          size: "medium",
          oldStyle: true,
          className: (0, _classnames.default)('btn', 'btn--secondary', 'group-details_hero__user-action-dropdown-btn', 'groups-v2-styles')
        }, (0, _preact.h)(_MoreHoriz.default, {
          className: "icon-dropdown",
          width: 24
        }))
      }, isCurrentUserModerator ? moderatorActions.map(function (action) {
        return (0, _preact.h)(_index.DropdownItem, {
          key: action.className
        }, (0, _preact.h)("button", {
          className: action.className,
          onClick: action.action,
          "data-bounded-context": "Groups",
          "data-entity": "manage-group",
          "data-track-type": "click",
          "data-element-name": action.elementName
        }, (0, _preact.h)(_phrase.default, {
          p: action.text
        })));
      }) : null, isUserMember ? (0, _preact.h)(_index.DropdownItem, null, isUserSubscribed ? (0, _preact.h)("button", {
        className: "user-action__group-subscription-btn",
        onClick: unsubscribe
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.unsubscribe.from.notifications"
      })) : (0, _preact.h)("button", {
        className: "user-action__group-subscription-btn",
        onClick: subscribe
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.subscribe.to.notifications"
      }))) : null, isUserMember ? (0, _preact.h)(_index.DropdownItem, {
        type: "alert"
      }, (0, _preact.h)("button", {
        className: "user-action__leave-group-btn",
        onClick: leaveGroup
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.leave.group"
      }))) : null), showAddMembersModal ? (0, _preact.h)(_GroupAddMembersModal.default, {
        groupId: groupId,
        onClose: function onClose() {
          return _this2.setState({
            showAddMembersModal: false
          });
        },
        communityLocale: communityLocale,
        showMessage: function showMessage(status, message) {
          return _this2.setState({
            showMessage: true,
            messageStatus: status,
            messageText: message
          });
        }
      }) : null, showEditFeaturedTopicsModal ? (0, _preact.h)(_GroupEditFeaturedTopicsModal.default, {
        groupId: groupId,
        title: curatedContentTitle,
        featuredTopics: curatedContentTopics,
        onClose: function onClose() {
          return _this2.setState({
            showEditFeaturedTopicsModal: false
          });
        },
        onSaveTopics: onSaveTopics
      }) : null, showMessage ? (0, _preact.h)(_message.default, {
        variant: messageStatus,
        onDismiss: function onDismiss() {
          return _this2.setState({
            showMessage: false
          });
        },
        timer: 5000
      }, messageText) : null);
    }
  }]);
  return ActionButtonsUserMember;
}(_preact.Component);

exports.ActionButtonsUserMember = ActionButtonsUserMember;

var GroupActionButtons = function GroupActionButtons(_ref) {
  var joinGroup = _ref.joinGroup,
      isLoading = _ref.isLoading,
      isUserMember = _ref.isUserMember,
      isCurrentUserModerator = _ref.isCurrentUserModerator,
      groupId = _ref.groupId,
      groupTitle = _ref.groupTitle,
      isUserSubscribed = _ref.isUserSubscribed,
      unsubscribe = _ref.unsubscribe,
      subscribe = _ref.subscribe,
      leaveGroup = _ref.leaveGroup,
      onManageGroupClick = _ref.onManageGroupClick,
      curatedContentTitle = _ref.curatedContentTitle,
      curatedContentTopics = _ref.curatedContentTopics,
      onSaveTopics = _ref.onSaveTopics,
      communityLocale = _ref.communityLocale;
  return (0, _preact.h)(_preactPortal.default, {
    key: "new-button",
    into: ".group-details-page_action-buttons"
  }, (0, _preact.h)("div", {
    className: "group-details-page_action-buttons__wrapper"
  }, !isUserMember ? (0, _preact.h)(_Button.default, {
    type: "button",
    className: "btn--cta btn",
    isLoading: isLoading,
    onClick: joinGroup,
    oldStyle: true,
    "data-bounded-context": "Groups",
    "data-entity": "group-join",
    "data-track-type": "click",
    "data-element-name": "Group Clicked Join"
  }, (0, _preact.h)(_phrase.default, {
    p: "groups.join.group"
  })) : null, isUserMember || isCurrentUserModerator ? (0, _preact.h)(ActionButtonsUserMember, {
    groupId: groupId,
    groupTitle: groupTitle,
    isUserSubscribed: isUserSubscribed,
    unsubscribe: unsubscribe,
    subscribe: subscribe,
    leaveGroup: leaveGroup,
    onManageGroupClick: onManageGroupClick,
    curatedContentTitle: curatedContentTitle,
    curatedContentTopics: curatedContentTopics,
    onSaveTopics: onSaveTopics,
    isCurrentUserModerator: isCurrentUserModerator,
    isUserMember: isUserMember,
    communityLocale: communityLocale
  }) : null));
};

var _default = GroupActionButtons;
exports.default = _default;